import(/* webpackMode: "eager" */ "/app/app/blogs/diary/page.tsx");
